import "./ai-coverage-summary.scss";

export const AiCoverageSummary = ({ coverage }) => {
  if (!coverage) return null;

  const percent = Math.round((coverage.percentage ?? 0) * 100);

  return (
    <div className="ai-coverage-summary">
      <div className="ai-coverage-summary__row">
        <span className="ai-coverage-summary__label">Coverage</span>
        <span className="ai-coverage-summary__value">
          {coverage.objectivesMatched} of {coverage.objectivesTotal} objectives
          matched ({percent}%)
        </span>
      </div>
      <div className="ai-coverage-summary__bar">
        <div
          className="ai-coverage-summary__bar-fill"
          style={{ "--coverage-pct": `${percent}%` }}
        />
      </div>
    </div>
  );
};
